import * as React from 'react';

import { compose } from 'recompose';

import { ShowMoreList } from '@coursera/cds-core';

import type { BrowseEntityPageContentProps } from 'bundles/browse/components/Domain/types/Cms';
import withGraphqlBrowseEntityContentfulFaqs from 'bundles/browse/components/Domain/withGraphqlBrowseEntityContentfulFaqs';
import { MAX_FAQS_TO_SHOW } from 'bundles/browse/constants';
import Faq from 'bundles/design-system/components/Faq';
import BrowseEntityFAQSchemaMarkup from 'bundles/seo/components/BrowseEntityFAQSchemaMarkup';

import _t from 'i18n!nls/browse';

import 'css!./__styles__/BrowseFAQs';

export type PropsFromCaller = {
  appSlug: string;
  faqTopic: string;
  isEntityPage?: boolean;
  faqSlug?: string | null;
  hideSchemaMarkup?: boolean;
};

type PropsFromStores = {
  pageContent?: BrowseEntityPageContentProps;
};

export type BrowseFaq = {
  domain?: string;
  question: string;
  answer: string;
};

type Props = PropsFromStores & PropsFromCaller;

export const BrowseFAQs = ({ hideSchemaMarkup, isEntityPage, faqTopic, pageContent }: Props) => {
  const faqs = pageContent?.faqs;

  if (!faqs || faqs.length === 0) {
    return null;
  }

  return (
    <div className="rc-BrowseFAQs">
      <h2 className="browse-faq__heading">{_t('Frequently Asked Questions about #{topic}', { topic: faqTopic })}</h2>
      <div className="rc-Faqs">
        <ShowMoreList
          numItemsToShow={MAX_FAQS_TO_SHOW}
          controllerProps={{ itemTypePlural: _t('frequently asked questions') }}
          className="faqList"
        >
          {faqs.map((faq, idx) => faq && <Faq key={faq.question} faq={faq} index={idx} isBrowsePage component="div" />)}
        </ShowMoreList>
      </div>
      <div className="faq-disclaimer">
        <span className="faq-disclaimer-text">
          {_t(
            'This FAQ content has been made available for informational purposes only. Learners are advised to conduct additional research to ensure that courses and other credentials pursued meet their personal, professional, and financial goals.'
          )}
        </span>
      </div>
      {!hideSchemaMarkup && <BrowseEntityFAQSchemaMarkup faqs={faqs} isEntityPage={isEntityPage} />}
    </div>
  );
};

export default compose<Props, Props>(
  withGraphqlBrowseEntityContentfulFaqs((props) => {
    return {
      appSlug: props.appSlug,
      isEntityPage: props.isEntityPage,
      contentType: 'browseEntityPage',
    };
  })
)(BrowseFAQs);
